import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, NgForm, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { HolidaysService } from '../../services/holidays.service';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { OrganizationAdminService } from 'src/app/modules/organization-admin/services/organization-admin.service';
import { Organization } from 'src/app/modules/organization-admin/models/organization';
import * as moment from 'moment';
@Component({
  selector: 'app-holiday-create',
  templateUrl: './holiday-create.component.html',
  styleUrls: ['./holiday-create.component.css']
})
export class HolidayCreateComponent implements OnInit {
  /** USING THIS TO RESET FORM  WITH OUT SHOWING FORMVALIDAITON ERRORS**/
  @ViewChild('myForm', {static: false}) myForm: NgForm;

  public holidayForm:FormGroup;
  public organizations:Organization;

  public hasRole:string = this.authservice.hasRole();
  public orgId:string;

  public isShowAlert:boolean= false;
  public isShowOrganization:boolean = false;


  constructor(private fb:FormBuilder,
    private dialog: MatDialog,
    private holidayService:HolidaysService,
    private authservice:AuthenticationService,
    private organizationService:OrganizationAdminService,

    ) { }

  ngOnInit(): void {
    this.createholidayForm();
    this.checkAuthenticationType();
  }

  checkAuthenticationType():void{
    if(this.hasRole == '1'){
      setTimeout(() => {
        this.getOrganizations();
      });
      this.isShowOrganization = true;
      this.orgId = '';
      this.holidayForm.get("org_id").setValidators([Validators.required]);
      this.holidayForm.get("org_id").updateValueAndValidity();
    }else{
      this.orgId = this.authservice.getOrgId();
    }
  }

  getOrganizations():void{
    this.organizationService.getOrganizations().subscribe(
      (res:any)=>{
        this.organizations = res.body;
      }
    );
  }

  createholidayForm(){
    this.holidayForm = this.fb.group({
      holiday_for: ['',[Validators.required]],
      holiday_on: ['',[Validators.required]],
      org_id	: [this.orgId]
    })
  }

  get holidayFormValidate(){
    return this.holidayForm.controls;
  }

  holidayFormSubmit(){
    if(this.holidayForm.invalid){
      return;
    }

    this.holidayForm.patchValue({
      holiday_on:moment(this.holidayForm.value.holiday_on).format('YYYY-MM-DD')
    });

    // console.log(this.holidayForm.value);

    this.holidayService.createHoliday(this.holidayForm.value).subscribe(
      (res)=>{
        this.holidayForm.reset();
        this.myForm.resetForm();
        this.isShowAlert= true;
        this.closeAlertMessage();
        this.createholidayForm();
        this.checkAuthenticationType();
      }
    )
  }

  cancel():void{
    this.dialog.closeAll();
  }

  closeAlertMessage(){
    setTimeout(()=>{
      this.isShowAlert=false;
    },5000);
  }

}
